import { FilterIcons, Line } from "@components/Filters/Filter"
import FilterContainer from "@components/Filters/FilterContainer"
import { useIntl } from "@components/Intl"
import { Box } from "@components/Layout"
import { SizeFilter, StyleFilter } from "@globalTypes"
import React, { Dispatch, FC } from "react"
import { FilterAction } from "../reducer"
import { Filter } from "./filter"

export type ProductGroup = {
  [name: string]: number
}

type SizeStyleFiltersProps = {
  availableSizes?: ProductGroup
  availableStyles?: ProductGroup
  activeStyle: StyleFilter | null
  activeSize: SizeFilter | null
  dispatch: Dispatch<FilterAction>
}

export const SizeStyleFilters: FC<SizeStyleFiltersProps> = ({
  availableSizes,
  availableStyles,
  activeSize,
  activeStyle,
  dispatch,
}) => {
  const { messages } = useIntl()
  const styles: FilterIcons[] = ["oval", "classic", "hippiechic"]
  const sizes: FilterIcons[] = ["small", "medium", "large"]
  return (
    <FilterContainer
      display="flex"
      justifyContent={["flex-start", "space-between"]}
      mb={4}
      pb={[4, 2]}
      mt={2}
    >
      <Box display="flex">
        {availableStyles && (
          <>
            <Filter
              onClick={() =>
                dispatch({
                  type: "set-style-filter",
                  style: null,
                })
              }
              showDeactivate={false}
              icon="allStyles"
              status={activeStyle === null ? "active" : "idle"}
            >
              {messages.search.allStyles}
            </Filter>
            {styles.map((style) => {
              let status = "idle"
              if (!availableStyles[style]) {
                status = "disabled"
              }
              if (style === activeStyle) {
                status = "active"
              }
              return (
                <Filter
                  key={style}
                  onClick={() =>
                    dispatch({
                      type: "set-style-filter",
                      style:
                        activeStyle === style ? null : (style as StyleFilter),
                    })
                  }
                  showDeactivate={true}
                  icon={style}
                  status={status as any}
                >
                  {messages.search[style]}
                </Filter>
              )
            })}
          </>
        )}
        {availableStyles && availableSizes && <Line />}
        {availableSizes && (
          <>
            <Filter
              onClick={() =>
                dispatch({
                  type: "set-size-filter",
                  size: null,
                })
              }
              showDeactivate={false}
              icon="allSizes"
              status={activeSize === null ? "active" : "idle"}
            >
              {messages.search.allSizes}
            </Filter>
            {sizes.map((size) => {
              let status = "idle"
              if (!availableSizes[size]) {
                status = "disabled"
              }
              if (size === activeSize) {
                status = "active"
              }
              return (
                <Filter
                  key={size}
                  onClick={() =>
                    dispatch({
                      type: "set-size-filter",
                      size: activeSize === size ? null : (size as SizeFilter),
                    })
                  }
                  showDeactivate={true}
                  icon={size}
                  status={status as any}
                >
                  {messages.search[size]}
                </Filter>
              )
            })}
          </>
        )}
      </Box>
    </FilterContainer>
  )
}
